import React, { useState, useRef, useEffect } from "react";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  FormControl,
  Typography,
  Tooltip,
  Grid,
  Card,
  Alert
} from "@mui/material";
import Uppy from '@uppy/core';
import { DragDrop, StatusBar } from '@uppy/react';
import XHRUpload from '@uppy/xhr-upload';
import '@uppy/core/dist/style.css';
import '@uppy/drag-drop/dist/style.css';
import '@uppy/status-bar/dist/style.css';
import '@uppy/informer/dist/style.css';
import DeleteIcon from "@mui/icons-material/Delete";
// import styled from "styled-components";
import cookey from "react-cookies";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import CloseIcon from "@mui/icons-material/Close";
import AttachmentService from "../../../services/api/attachmentService";
import SupportService from "../../../services/api/supportService";
import RichTextEditor from "../../RichTextEditor";
import EnhancedTable from "../../../components/sections/enhancedTable";

import { SupportContainer, CloseBtn } from "./styles";
import CustomizedSnackbars from "../../CustomizedSnackbars";
import { getUniqueFileName } from "../../../utils/common/attachment";

const PREFIX = "SupportDialog";

const classes = {
  nodatatext: `${PREFIX}-nodatatext`,
};

library.add(fas);

const SupportDialog = ({ open, handleClose, boardDetails }) => {
  // state declarations

  const [files, setFiles] = useState([]);
  const [loader, setLoader] = useState(false);
  const [description, setDescription] = useState(null);
  const [formData, setFormData] = useState({
    maxFileSize: boardDetails.fileSize,
  });
  const [openMyRequests, setOpenMyRequests] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [tableData, setTableData] = React.useState([]);
  const [uppyInstance, setUppyInstance] = useState(null);
  const [errorMessages, setErrorMessages] = useState([]);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [errorToastMessage, setErrorToastMessage] = useState('');
  const uploadedFilesRef = useRef([]);

  React.useEffect(() => {
    const uppy = new Uppy({
      autoProceed: true,
      allowMultipleUploads: true,
      restrictions: {
        maxFileSize: boardDetails?.fileSizeDisplay * 1024 * 1024,
      },
      onBeforeFileAdded: (currentFile, files) => {
        const uniqueName = getUniqueFileName(currentFile.name, uploadedFilesRef.current);
        if (uniqueName !== currentFile.name) {
          return {
            ...currentFile,
            name: uniqueName,
            meta: { ...currentFile.meta, name: uniqueName }
          };
        }
        return currentFile;
      }
    })
      .use(XHRUpload, {
        endpoint: '/api/fileupload?type=tickets',
        method: 'POST',
        fieldName: 'file',
        formData: true
      })
      .on('files-added', (files) => {
        setErrorMessages([]);
      })
      .on('restriction-failed', (file, error) => {
        setErrorMessages(prev => {
          const newErrors = [...prev, `${file.name}: ${error.message}`];
          setErrorToastMessage(newErrors);
          setShowErrorToast(true);
          return newErrors;
        });
      })
      .on('upload-success', (file, response) => {
        uploadedFilesRef.current.push({ attachment_name: file.name });
        file.originalname = response.body.filename;
        setFiles(prev => [...prev, file]);
      });

    setUppyInstance(uppy);

    return () => {
      if (uppy) {
        uppy.close();
      }
    };
  }, [boardDetails, open]);

  // Auto-close toast after 10 seconds
  React.useEffect(() => {
    if (showErrorToast) {
      const timer = setTimeout(() => setShowErrorToast(false), 10000);
      return () => clearTimeout(timer);
    }
  }, [showErrorToast]);

  const headCells = [
    {
      id: "originalkey",
      numeric: false,
      width: "5",
      page: "View Submitted Request",
    },
    {
      id: "ticket_number",
      numeric: false,
      label: "Ticket Number",
      width: "20",
    },
    {
      id: "requested_by",
      numeric: false,
      label: "Created By",
      width: "10",
      type: "username",
    },
    {
      id: "requested_for",
      numeric: false,
      label: "Requested For",
      width: "10",
      type: "username",
    },
    {
      id: "created_sort",
      type: "date",
      numeric: false,
      label: "Created On",
      width: "15",
    },
    {
      id: "short_desc",
      numeric: false,
      label: "Ticket Detail",
      width: "30",
    },
  ];

  useEffect(() => {
    setFormData({
      maxFileSize: boardDetails.fileSize,
    });
  }, [boardDetails, open]);

  const handleChange = (value) => {
    setDescription(value);
  };
  const cancelDialog = () => {
    handleClose();
  };

  // remove attachment
  const removeAttachment = (file) => {
    if (file) {
      files.forEach((fileitem, i) => {
        if (fileitem.name === file.name) {
          AttachmentService.removeFileUpload({
            filename: file.originalname,
          }).then((_response) => {
            files.splice(i, 1);
            setFiles([...files]);
            uploadedFilesRef.current.splice(i, 1);
          });
        }
      });
    }
  };

  const submitRequest = () => {
    const date = new Date();
    let input = {};
    let reqDetails = {};

    formData.attachmentAnchorTag = "";
    if (files.length > 0) {
      formData.attachmentAnchorTag = "<br>Attachments :";
      files.forEach((item, i) => {
        if (item.originalname !== undefined) {
          formData.attachmentAnchorTag = `${formData.attachmentAnchorTag} </br><a href='https://${document.location.hostname}/api/uploads/${item.originalname}'>https://${document.location.hostname}/api/uploads/${item.originalname}</a>`;
        }
      });
    }

    reqDetails = {
      Type: "General Questions",
      Application: "JJKanban",
      "Requested Date": date.toString(),
      "Created By": cookey.load("username").toUpperCase(),
      Description: `${description} ${formData.attachmentAnchorTag}`,
    };

    input = {
      request_for: cookey.load("username"),
      assgn_grp: "AS FRAD TOOLS L2",
      task_srt: "General Questions",
      req_det: reqDetails,
      sla: "5",
      application: "kanban",
    };

    setLoader(true);
    SupportService.ticketCreation(input).then(
      (response) => {
        setLoader(false);
        if (
          response.data.body.result.statusCode === 200 ||
          response.data.body.result.statusMessage === "Success"
        ) {
          setDescription(null);
          setFiles([]);
          setSuccessMessage({
            success: true,
            message: `Support request submitted successfully 
          and your request number is ${response.data.body.result.returnResponse.requestNumber} - ${response.data.body.result.returnResponse.requestedItem}`,
          });
        } else {
          setSuccessMessage({
            success: false,
            message: "Something went wrong. Contact system administrator!",
          });
        }
      },
      (error) => {
        setLoader(false);
        if (error) {
          setSuccessMessage({
            success: false,
            message: "Something went wrong. Contact system administrator!",
          });
        }
      }
    );
  };

  const handleSubmittedRequests = () => {
    setOpenMyRequests(true);
    setLoader(true);
    SupportService.getSupportTicketDetails(cookey.load("username")).then(
      (result) => {
        setLoader(false);
        const tempArray = result.data;
        tempArray.map((item, i) => {
          // eslint-disable-next-line prefer-destructuring
          tempArray[i].short_desc = tempArray[i].ticket_detail
            .toString()
            .split("|")[1];
        });
        setTableData(tempArray);
      }
    );
  };

  return (
    <div>
      <CloseBtn className="closeIcon dialogClose" onClick={cancelDialog}>
        <Tooltip title="Close">
          <CloseIcon />
        </Tooltip>
      </CloseBtn>
      <SupportContainer>
        {successMessage && successMessage.success && (
          <Alert severity="success" onClose={() => setSuccessMessage(null)}>
            {successMessage.message}
          </Alert>
        )}
        {successMessage && !successMessage.success && (
          <Alert severity="error" onClose={() => setSuccessMessage(null)}>
            {successMessage.message}
          </Alert>
        )}

        <DialogTitle>
          {openMyRequests ? "Submitted Requests" : "Support Request"}
          <div className="pull-right requestBtn">
            {openMyRequests ? (
              <Button
                variant="outlined"
                onClick={() => setOpenMyRequests(false)}
              >
                Back
              </Button>
            ) : (
              <Button color="primary" onClick={handleSubmittedRequests}>
                View submitted support requests
              </Button>
            )}
          </div>
        </DialogTitle>
        <DialogContent>
          {openMyRequests ? (
            <div>
              {!loader && !tableData.length ? (
                <div className={classes.nodatatext}>No records found</div>
              ) : null}
              {tableData.length ? (
                <EnhancedTable
                  key="history-table"
                  orderby="created_sort"
                  headCells={headCells}
                  rowsData={tableData}
                  sortorder="desc"
                />
              ) : null}
            </div>
          ) : (
            <div>
              <FormControl
                variant="standard"
                style={{
                  width: "100%",
                  padding: 10,
                }}
              >
                <div
                  className="cardContainerLabel"
                  style={{
                    marginBottom: 10,
                  }}
                >
                  <span>Ticket Description</span>
                </div>
                {boardDetails && (
                  <RichTextEditor
                    boardid={boardDetails.id}
                    mentionsRequried="true"
                    editorValue={description}
                    handleEditorChange={handleChange}
                    showTablesModule="false"
                    showTextModule="true"
                  />
                )}
                <Grid
                  container
                  spacing={1}
                  style={{
                    marginTop: 20,
                  }}
                >
                  <FormControl
                    variant="standard"
                    style={{
                      width: "100%",
                    }}
                  >
                    <Typography fontWeight={'bold'}>Attachments</Typography>
                    {uppyInstance && (
                      <>
                        <DragDrop
                          uppy={uppyInstance}
                          note={`Drag files here or click to browse. ${boardDetails.fileSizeDisplay ? `Max size: ${boardDetails.fileSizeDisplay} MB` : ''}`}
                        />
                        <StatusBar
                          uppy={uppyInstance}
                          hideUploadButton={true}
                          hideRetryButton={true}
                          hidePauseResumeButton={true}
                          hideCancelButton={true}
                          showProgressDetails={true}
                        />
                      </>
                    )}
                    {
                      files.length > 0 &&
                      <Card
                        variant="outlined"
                        sx={{
                          p: 2,
                          mt: 2,
                          borderWidth: '1.5px',
                          borderColor: "#adadad",
                          borderRadius: '7px'
                        }}
                      >
                        {
                          files?.toReversed()?.map((file, index) => (
                            <Grid container alignItems={'center'} key={index}>
                              <Grid item xs={10}>
                                <Typography>{file.name}</Typography>
                              </Grid>
                              <Grid item xs={2}>
                                <IconButton onClick={() => removeAttachment(file)}>
                                  <DeleteIcon color="error" />
                                </IconButton>
                              </Grid>
                            </Grid>
                          ))
                        }
                      </Card>
                    }
                  </FormControl>
                </Grid>
                <Grid />
              </FormControl>
            </div>
          )}
        </DialogContent>
        {!openMyRequests && (
          <DialogActions>
            <Button
              onClick={cancelDialog}
              variant="outlined"
              color="default_button"
            >
              Cancel
            </Button>

            <Button
              color="primary"
              variant="outlined"
              disabled={!description || loader || description === "<p><br></p>"}
              onClick={submitRequest}
            >
              Submit
            </Button>
          </DialogActions>
        )}
        {showErrorToast && (
          <CustomizedSnackbars
            messageType="error"
            message={Array.isArray(errorToastMessage) ?
              errorToastMessage.map((error, index) => (
                <div key={index}>{error}</div>
              )) : errorToastMessage
            }
          />
        )}
      </SupportContainer>
    </div>
  );
};

export default SupportDialog;
